var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverduepayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38826",
    x: 21.838,
    y: 21.954,
    width: 19.048,
    height: 19.047,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overdue_payment",
    "data-name": "Overdue payment",
    transform: "translate(-1043.518 -877.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38822",
    "data-name": "Path 38822",
    d: "M26,0A26,26,0,1,1,0,26,26,26,0,0,1,26,0",
    transform: "translate(1043.518 877.263)",
    fill: "#d31d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38823",
    "data-name": "Path 38823",
    d: "M11.814,37.939l3.7,3.516,3.807-3.62,3.873,3.683,3.782-3.595L30.74,41.5l4.016-3.82,3.37,3.384V6.561H7.988v34.79Z",
    transform: "translate(1046.461 879.68)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38824",
    "data-name": "Path 38824",
    d: "M26.5,11.088H10.72a1.094,1.094,0,1,1,0-2.188H26.5a1.094,1.094,0,0,1,0,2.188",
    transform: "translate(1049.237 882.945)",
    fill: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38825",
    "data-name": "Path 38825",
    d: "M21.782,15.277H10.72a1.094,1.094,0,1,1,0-2.188H21.782a1.094,1.094,0,0,1,0,2.188",
    transform: "translate(1049.236 885.62)",
    fill: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1043.52, 877.26)",
    filter: "url(#Path_38826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38826-2",
    "data-name": "Path 38826",
    d: "M30.006,21.811a8.024,8.024,0,1,1-8.024-8.024,8.024,8.024,0,0,1,8.024,8.024",
    transform: "translate(9.38 8.67)",
    fill: "#e50019"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38827",
    "data-name": "Path 38827",
    d: "M18.385,24.3a.809.809,0,0,1,.814-.855.857.857,0,0,1,0,1.711.808.808,0,0,1-.814-.855m.345-1.975L18.537,15.7h1.325l-.193,6.627Z",
    transform: "translate(1055.947 887.193)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverduepayment);
export default __webpack_public_path__ + "static/media/Overdue payment.0004134181a46c4422e1f05ec95db20a.svg";
export { ForwardRef as ReactComponent };